import { AllFeaturesSection } from "./features/AllFeaturesSection";
import { Divider } from "./Divider";
import { DownloadOnAppStoreButton } from "./DownloadOnAppStoreButton";
import { HeroScreenshots } from "./hero/HeroScreenshots";
import styles from "./Home.module.scss";
import { accessibilityLabels } from "./accessibilityLabels";

const Home: React.FC = () => {
  return (
    <div className={styles.home} style={{ display: "flex", paddingBottom: 10 }}>
      <h1
        style={{ marginTop: 10, marginBottom: 0 }}
        aria-label={accessibilityLabels.heading}
      >
        ChiGo
      </h1>

      <p
        style={{
          margin: 0,
          fontWeight: 500,
          marginBottom: 20,
        }}
      >
        Chicago transit, simplified.
      </p>

      <HeroScreenshots />

      <DownloadOnAppStoreButton style={{ marginBottom: 10, marginTop: 30 }} />

      <Divider />

      <AllFeaturesSection />

      <DownloadOnAppStoreButton style={{ marginTop: 40 }} />

      <div className={styles.links}>
        <a href="/privacy">Privacy Policy</a>
        <a href="/terms">Terms of Service</a>
        <a href="/contact">Contact Us</a>
      </div>
    </div>
  );
};

export default Home;
